import React from "react";
import LocationMapPicker from "./LocationMapPicker";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

type Location = {
  lat: number;
  lng: number;
  address?: string;
};

type MapModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelectLocation: (location: Location) => void;
  title?: string;
};

const GmapModal = ({
  isOpen,
  onClose,
  onSelectLocation,
  title = "Pick a location",
}: MapModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        onInteractOutside={(e) => {
          const target = e.target as HTMLElement;
          if (target.closest(".pac-container")) {
            e.preventDefault(); // Prevent modal from closing
          }
        }}
        className="w-full max-w-5xl h-[700px] p-8 mt-0 overflow-hidden rounded-3xl flex flex-col"
      >
        <DialogTitle className="m-0 p-0 text-center">{title}</DialogTitle>

        <LocationMapPicker
          onClose={onClose}
          onSelectLocation={onSelectLocation}
        />
      </DialogContent>
    </Dialog>
  );
};

export default GmapModal;
